import cxs from 'cxs';
import { COLOURS, FLATTENED_COLOURS } from '../../../common/styles/vars';

const isImportant = (style) => `${style} !important`;

const ROUNDED_IMAGE = ({ circular }) => ({
  border: circular ? '1px solid rgba(0, 0, 0, 0)' : void 0,
  borderRadius: circular ? '50%' : '4px',
  backgroundSize: circular ? 'cover' : void 0,
  overflow: 'hidden'
});

export const IMAGE = (
{ clickable, circular, rounded }) =>
cxs({
  alignItems: 'center',
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  display: 'inline-flex',
  position: 'relative',
  borderWidth: isImportant('0px'),
  pointer: clickable ? 'cursor' : 'default',

  ...(circular || rounded ? ROUNDED_IMAGE({ circular }) : {})
});

export const IMAGE_ICON = (
{
  background,
  width,
  height,
  defaultIconSize,
  color







}) => cxs({
  alignItems: 'center',
  display: 'flex',
  justifyContent: 'center',
  // $FlowFixMe this is defaulted in defaultProps
  background: FLATTENED_COLOURS[background],
  // $FlowFixMe this is defaulted in defaultProps
  height,
  // $FlowFixMe this is defaulted in defaultProps
  width,

  ...(
  color ?
  {
    ' > .text': { color: `${FLATTENED_COLOURS[color]} !important` }
  } :
  {}),


  ...(
  defaultIconSize ?
  {} :
  {
    ' > .icon-container': {
      height: '60%',
      width: '60%',

      ' > .icon': {
        height: '100% !important',
        width: '100% !important'
      },

      ' > .icon > svg': {
        height: '100% !important',
        width: '100% !important'
      }
    }
  })

});

export const IMAGE_EDIT = cxs({
  alignItems: 'center',
  background: COLOURS.mono.black,
  bottom: '0',
  color: COLOURS.mono.white,
  display: 'flex',
  gap: '6px',
  fontSize: '10px',
  opacity: '0.75',
  position: 'absolute',
  right: '0',
  height: '20px',
  width: '75px',
  justifyContent: 'center',

  ' > .icon-container': {
    marginRight: '10px'
  },

  ' > p': {
    paddingTop: '2px',
    fontSize: '12px',
    margin: 0,
    lineHeight: '12px'
  }
});